/**
 * @name: 获取时间描述： 刚刚，几分钟前，几天前。。。
 * @param {string} dateTimeStamp 需要判断的时间戳
 * @return {string} 时间描述
 */
 import {dateFormat} from "./DateUtil";

 export default dateTimeStamp => {
	 if(!dateTimeStamp){
		 return
	 }
	 if(typeof  dateTimeStamp == "string"){
		 let strings = dateTimeStamp.split(/[T.]/g);
		 strings[0] = strings[0].replace(/-/g, "/")
		 var s = strings[0] + ' ' + strings[1];
		 dateTimeStamp = new Date(s)
	 }
 
	 let result
	 var minute = 1000 * 60;
	 var hour = minute * 60;
	 var day = hour * 24;
	 var halfamonth = day * 15;
	 var month = day * 30;
	 var now = new Date().getTime();
	 var diffValue = now - dateTimeStamp;
	 if (diffValue < 0) {
		 return;
	 }
	 var monthC = diffValue / month;
	 var weekC = diffValue / (7 * day);
	 var dayC = diffValue / day;
	 var hourC = diffValue / hour;
	 var minC = diffValue / minute;
	 if (monthC >= 1) {
		 result = "" + parseInt(monthC) + "月前";
		 return result
 
	 } else if (weekC >= 1) {
		 result = "" + parseInt(weekC) + "周前";
		 return result
	 } else if (dayC >= 1) {
		 result = "" + parseInt(dayC) + "天前";
	 } else if (hourC >= 1) {
		 result = "" + parseInt(hourC) + "小时前";
	 } else if (minC >= 1) {
		 result = "" + parseInt(minC) + "分钟前";
	 } else if (minC < 1) {
		 result = "刚刚";
	 }
	 return result;
 }